// extracted by mini-css-extract-plugin
module.exports = {"m-l-1":"Spaces_m-l-1__2Isoc","container":"RemoveAction_container__15-AA Spaces_m-l-1__2Isoc","icon":"RemoveAction_icon__1vhvj"};